import React, { useEffect, useState } from "react";
import { InputField } from "../../../../Components/formElements/InputField";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ItemService from "../../../../services/customer_appCommonService";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import {
  formatDateWithAMPM,
  getTodayDate,
  validateContactNumber,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
import MaterialSelectionModal from "./MaterialSelectionModal";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import TableDropdownMenu from "../../../../Components/TableDropdownMenu/TableDropdownMenu";
import CreditPolicyRequestFormOrderBookingModal from "../CreditPolicy/CreditPolicyRequestFormOrderBookingModal";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import Layout from "../../../../Layout/Layout";
import accountsApi from "../../../../services/accountsCommonService";
import { ObjectId } from "bson";
const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE: "Enter a 6-character postal code.",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
};

const OrderBookingCreation = React.forwardRef((props, ref) => {
  let userData = useSelector((state) => state?.user?.data);
  const navigate = useNavigate();

  const exForDropdownData = [
    { id: 1, name: "Ex-Work" },
    { id: 2, name: "FOR" },
  ];
  // const priority = [
  //   { id: 1, name: "Load and Halt" },
  //   { id: 2, name: "Concrete" },
  //   { id: 3, name: "Customer Emergency" },
  //   { id: 4, name: "Medium" },
  // ];
  const priority = [
    { id: 1, code: "LH", name: "Load and Halt" },
    { id: 2, code: "CON", name: "Concrete" },
    { id: 3, code: "CE", name: "Customer Emergency" },
    { id: 4, code: "MED", name: "Medium" },
  ];
  let productDetailsCol = [
    {
      name: "Sl.No",
      selector: (row) => row.local_id || "--",
      cell: (row) => <>{row.local_id}.</>,
      sortable: true,
      width: "80px",
    },
    {
      name: "Material",
      selector: (row) => row.materialLongText,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.materialLongText}{" "}
          </p>
          <p className="m-0 p-0 ">{row.materialCode} </p>
        </div>
      ),
    },
    // {
    //   name: "A/C",
    //   selector: (row) => row.accOnOff,
    //   sortable: true,
    //   width: "120px",
    //   cell: (row) => (
    //     <div className="form-check form-switch">
    //       <input
    //         className="form-check-input custom-switch"
    //         type="checkbox"
    //         role="switch"
    //         id={`switch-${row.local_id}`}
    //         checked={row.accOnOff === true}
    //         onChange={(event) => handleCheckboxChange(row.local_id, event)}
    //       />
    //     </div>
    //   ),
    // },
    {
      name: "A/C",
      selector: (row) => row.accOnOff,
      sortable: true,
      width: "120px",
      cell: (row) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input custom-switch"
            type="checkbox"
            role="switch"
            id={`switch-${row.local_id}`}
            checked={row.accOnOff === true}
            onChange={(event) => handleCheckboxChange(row.local_id, event)}
          />
        </div>
      ),
    },
    {
      name: "UOM",
      selector: (row) => row.uOM || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Qty",
      selector: (row) => row.orderQuantityLoad || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderQuantityLoad"
          placeholder=""
          value={row.orderQuantityLoad || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="unitPrice"
          placeholder=""
          value={row.unitPrice || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "EX/FOR",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"EX/FOR"}
            data={exForDropdownData}
            id={"exWork"}
            name={"exWork"}
            code={"exWorkCode"}
            description={"exWorkDescription"}
            onChange={handleDropdownChange}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },

    {
      name: "Truck Nr",
      selector: (row) => row.loadingTruckNo || "--",
      cell: (row) => (
        <>
          {row?.exWork === "Ex-Work" ? (
            <>
              <InputField
                className="inputBox"
                name="loadingTruckNo"
                id="loadingTruckNo"
                value={row?.loadingTruckNo}
                onChange={(event) => handleInputChange(row.local_id, event)}
              />
            </>
          ) : (
            <>--</>
          )}
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Priority",
      cell: (row) => (
        <>
          <TableDropdownMenu
            index={row?.local_id}
            label={"Priority"}
            data={priority}
            id={"priority"}
            name={"priority"}
            code={"priorityCode"}
            description={"priorityDescription"}
            onChange={handleDropdownChange}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Dispatch Date",
      selector: (row) => row.dispatchDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="dispatchDate"
          type="date"
          placeholder=""
          value={row.dispatchDate || getTodayDate("")}
          disabled={false}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Shipping Address",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <>
          <TextAreaField
            className="inputBox mt-1"
            name="shippingAddress"
            placeholder=""
            value={row.isShippingEdited ? row.shippingAddress : ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        </>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Ship to Party",
      selector: (row) => row.shipToParty || false,
      cell: (row) => (
        <input
          className="form-check-input"
          type="checkbox"
          checked={row.shipToParty || false}
          onChange={(e) => {
            const checked = e.target.checked;

            setProductDetailsData((prev) =>
              prev.map((item) =>
                item.local_id === row.local_id
                  ? {
                      ...item,
                      shipToParty: checked,
                    }
                  : item,
              ),
            );
          }}
        />
      ),
      width: "130px",
    },
    {
      name: "Pin Code",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="shippingPostalCode"
          placeholder=""
          value={row.isPostalEdited ? row.shippingPostalCode : ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Remarks",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="dispatchRemarks"
          placeholder=""
          value={row.dispatchRemarks || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Text")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button className="" onClick={() => removeProductDetails(row.local_id)}>
          <i className="bi bi-trash text-danger fs-4" />
        </button>
      ),
      width: "120px",
    },
  ];

  const defaultCustomerDetails = {
    customerName: "",
    address: "",
    address2: "",
    address3: "",
    state: "",
    cityPostalCode: "",
    certifications: "",
  };
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };

  const getInitialFormInputs = () => ({
    orderStatus: "Pending",
    salesOrderStatus: "Created",
    orderPlacedBy: "",
    customerDetails: "",
    emailAddress: "",
    deliveryAddress: "",
    customerDetailsIfOther: "",
    additionalCreditAmt: "",
    createdDate: new Date(),
    createdBy: userData?.userId,
    dispatchDate: getTodayDate(""),
  });

  const [modalShow, setModalShow] = useState(false);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);

  const [getDropdownData, setDropdownData] = useState("");
  const [getProductDetailsData, setProductDetailsData] = useState([]);

  const [getProductDetailsCol] = useState(productDetailsCol);

  const [disable, setDisabled] = useState(false);
   // eslint-disable-next-line 
  const [getCustomer, setCustomer] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [getProjects, setProjects] = useState([]);
  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [getCompanyDetails, setCompanyDetails] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [getProjectDetails, setProjectDetails] = useState([]);
  const [getProjectDetailsSave, setProjectDetailsSave] = useState([]);
  const [customerID, setCustomerID] = useState("");
  const [orderTotalValue, setOrderTotalValue] = useState(0);

  const [getShowFailureModal, setShowFailureModal] = useState(false);

  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const [getCreditPolicyFormModal, setCreditPolicyFormModal] = useState(false);
   // eslint-disable-next-line 
  const [toggleCreditRequest, setToggleCreditRequest] = useState(false);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const [formInputs, setFormInputs] = useState(getInitialFormInputs());

  const [validation, setValidation] = useState({});

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const [accountsCustomers, setAccountsCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [customerLoading, setCustomerLoading] = useState(false);

  useEffect(() => {
    let active = true;

    const loadCustomers = async () => {
      try {
        setCustomerLoading(true);

        const result = await accountsApi.customers({
          isActive: "true",
        });

        if (active) {
          setAccountsCustomers(Array.isArray(result?.data) ? result.data : []);
        }
      } catch (error) {
        console.error("Customer loading error:", error);
        toast.error("Unable to load customers");
      } finally {
        if (active) setCustomerLoading(false);
      }
    };

    loadCustomers();

    return () => {
      active = false;
    };
  }, []);

  const [customerCredit, setCustomerCredit] = useState(null);
  const [creditLoading, setCreditLoading] = useState(false);
  const [creditError, setCreditError] = useState("");

  const getCustomerCredit = async (customerId) => {
    if (!customerId) {
      setCustomerCredit(null);
      setCreditError("");
      return;
    }

    try {
      setCreditLoading(true);
      setCreditError("");

      const result = await accountsApi.customerCredit(customerId);

      console.log("Customer Credit Response:", result);

      if (result?.data) {
        setCustomerCredit(result.data);
      } else {
        setCustomerCredit(null);
        setCreditError("Customer credit details not found");
      }
    } catch (error) {
      console.error("Customer credit error:", error);

      setCustomerCredit(null);

      setCreditError(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to fetch customer credit",
      );
    } finally {
      setCreditLoading(false);
    }
  };
  useEffect(() => {
    loadMasterData();
    setOrderTotalValue(0);
    setFormInputs(getInitialFormInputs());
    setProductDetailsData([]);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
      }));
      getProjectNameData(getDropdownData?.id);
      getCustomerDetail(getDropdownData?.id);
      setCustomerID(getDropdownData?.id);
      setFormInputs((formInputs) => ({ ...formInputs, projectName: "" }));
      setProjectDetails([]);
      setProjectDetailsSave([]);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
    } else if (getDropdownData?.textCode === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      getCompanyMaster(getDropdownData?.id);
      customerDataDropdown(getDropdownData?.id);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line
  }, [getDropdownData]);

  const [othersCustomer, setOthersCustomer] = useState(false);
  const onCheckBoxChange = (event) => {
    setOthersCustomer(event.target.checked);
    setCustomerDetails(defaultCustomerDetails);
  };

  const [addOnInv, setAddOnInv] = useState(false);
  const addOnInvoiceChange = (event) => {
    setAddOnInv(event.target.checked);
  };

  const removeProductDetails = (local_id) => {
    setProductDetailsData((prevPrograms) => {
      const filteredData = prevPrograms.filter(
        (program) => program.local_id !== local_id,
      );
      const updatedData = filteredData.map((item, index) => ({
        ...item,
        local_id: index + 1,
        orderQuantityLoad: "",
      }));
      return updatedData;
    });
  };

  // const handleInputChange = (local_id, event, type) => {
  //   const { name, value } = event.target;

  //   if (type === "Number" && isNaN(value)) {
  //     toast.error("Please enter a valid number");
  //     return;
  //   }

  //   setProductDetailsData((prev) =>
  //     prev.map((row) => {
  //       if (row.local_id !== local_id) return row;

  //       let updatedRow = { ...row, [name]: value };

  //       if (name === "shippingAddress") {
  //         updatedRow.isShippingEdited = true;

  //         if (value.trim()) {
  //           updatedRow.shippingPostalCode = "";
  //           updatedRow.isPostalEdited = true;
  //         } else {
  //           updatedRow.shippingAddress = updatedRow.originalShippingAddress;
  //           updatedRow.shippingPostalCode =
  //             updatedRow.originalShippingPostalCode || "";
  //           updatedRow.isPostalEdited = false;
  //         }
  //       }

  //       if (name === "shippingPostalCode") {
  //         updatedRow.isPostalEdited = true;
  //         updatedRow.shippingPostalCode = value;
  //       }

  //       const qty = parseFloat(updatedRow.orderQuantityLoad) || 0;
  //       const price = parseFloat(updatedRow.unitPrice) || 0;

  //       const reversePercentage = parseFloat(updatedRow.reversePercentage) || 1;
  //       const cgst = parseFloat(updatedRow.cgst) || 0;
  //       const sgst = parseFloat(updatedRow.sgst) || 0;

  //       const gst = cgst + sgst;
  //       updatedRow.gst = gst;

  //       updatedRow.basicPrice = price / reversePercentage || 0;
  //       updatedRow.basicAmount = (updatedRow.basicPrice * qty).toFixed(2);

  //       updatedRow.cgstValue = ((cgst * updatedRow.basicAmount) / 100).toFixed(
  //         2,
  //       );
  //       updatedRow.sgstValue = ((sgst * updatedRow.basicAmount) / 100).toFixed(
  //         2,
  //       );
  //       updatedRow.gstValue = ((gst * updatedRow.basicAmount) / 100).toFixed(2);

  //       updatedRow.rate = (qty * price).toFixed(2);
  //       updatedRow.amount = (qty * price).toFixed(2);

  //       updatedRow.netValue = (
  //         parseFloat(updatedRow.basicAmount) + parseFloat(updatedRow.gstValue)
  //       ).toFixed(2);

  //       return updatedRow;
  //     }),
  //   );
  // };
  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;

    if (type === "Number" && value !== "" && isNaN(Number(value))) {
      toast.error("Please enter a valid number");
      return;
    }

    setProductDetailsData((prev) =>
      prev.map((row) => {
        if (row.local_id !== local_id) return row;

        let updatedRow = { ...row, [name]: value };

        if (name === "shippingAddress") {
          updatedRow.isShippingEdited = true;

          if (value.trim()) {
            updatedRow.shippingPostalCode = "";
            updatedRow.isPostalEdited = true;
          } else {
            updatedRow.shippingAddress = updatedRow.originalShippingAddress;
            updatedRow.shippingPostalCode =
              updatedRow.originalShippingPostalCode || "";
            updatedRow.isPostalEdited = false;
          }
        }

        if (name === "shippingPostalCode") {
          updatedRow.isPostalEdited = true;
          updatedRow.shippingPostalCode = value;
        }

        const qty = Number(updatedRow.orderQuantityLoad) || 0;
        const price = Number(updatedRow.unitPrice) || 0;
        const reversePercentage = Number(updatedRow.reversePercentage) || 1;
        const cgst = Number(updatedRow.cgst) || 0;
        const sgst = Number(updatedRow.sgst) || 0;

        const gst = cgst + sgst;
        updatedRow.gst = gst;

        updatedRow.basicPrice = Number((price / reversePercentage).toFixed(2));

        updatedRow.basicAmount = Number(
          (updatedRow.basicPrice * qty).toFixed(2),
        );

        updatedRow.cgstValue = Number(
          ((cgst * updatedRow.basicAmount) / 100).toFixed(2),
        );

        updatedRow.sgstValue = Number(
          ((sgst * updatedRow.basicAmount) / 100).toFixed(2),
        );

        updatedRow.gstValue = Number(
          ((gst * updatedRow.basicAmount) / 100).toFixed(2),
        );

        updatedRow.rate = Number((qty * price).toFixed(2));
        updatedRow.amount = Number((qty * price).toFixed(2));

        updatedRow.netValue = Number(
          (updatedRow.basicAmount + updatedRow.gstValue).toFixed(2),
        );

        return updatedRow;
      }),
    );
  };
  useEffect(() => {
    if (getProductDetailsData.length === 0) {
      setOrderTotalValue("");
      return;
    }
    const total = getProductDetailsData.reduce((sum, row) => {
      const qty = parseFloat(row.orderQuantityLoad) || 0;
      const price = parseFloat(row.unitPrice) || 0;
      return sum + qty * price;
    }, 0);
    setOrderTotalValue(total.toFixed(2));
  }, [getProductDetailsData]);

  const othersOnInputChange = ({ target: { name, value } }) => {
    const errors = {};

    setCustomerDetails((customerDetails) => ({
      ...customerDetails,
      [name]: value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };
  //eslint-disable-next-line
  const [currentOutstandingAmt, setCurrentOutstandingAmt] = useState(0);

  useEffect(() => {
    const maxLimit =
      Number(getCustomerDetails?.companyProfile?.creditMaxLimit) || 0;
    const available =
      Number(getCustomerDetails?.companyProfile?.creditAvailableAmt) || 0;

    const outstanding = maxLimit - available;

    setCurrentOutstandingAmt(outstanding.toFixed(2));
  }, [getCustomerDetails]);

  // const createAccountsOrder = async (savedOrder) => {
  //   try {
  //     const payload = {
  //       customerId: selectedCustomerId,

  //       customerName: formInputs?.customerName || "",

  //       items: getProductDetailsData.map((item) => ({
  //         description: item?.productName || item?.description || "",

  //         quantity: Number(item?.orderQuantityLoad) || 0,

  //         unit: item?.unit || item?.uom || "",

  //         rate: Number(item?.unitPrice) || 0,

  //         amount:
  //           (Number(item?.orderQuantityLoad) || 0) *
  //           (Number(item?.unitPrice) || 0),
  //       })),

  //       totalAmount: Number(orderTotalValue) || 0,

  //       remarks: formInputs?.remarks || "",

  //       status: "APPROVED",

  //       creditCheck: {
  //         creditLimit: Number(customerCredit?.creditLimit) || 0,

  //         outstanding: Number(customerCredit?.outstanding) || 0,

  //         openOrders: Number(customerCredit?.openOrders) || 0,

  //         orderAmount: Number(orderTotalValue) || 0,

  //         exceededBy: creditExceeded
  //           ? Math.abs(Number(creditAvailable) || 0)
  //           : 0,

  //         passed: !creditExceeded,
  //       },

  //       approvedAt: null,

  //       approvalNote: "",

  //       cancelledAt: null,

  //       cancelReason: "",
  //     };

  //     console.log("Orders API Payload:", payload);

  //     const response = await accountsApi.orders(payload);

  //     console.log("Orders API Response:", response);

  //     return response;
  //   } catch (error) {
  //     console.error("Orders API Error:", error);

  //     throw error;
  //   }
  // };
   // eslint-disable-next-line 
  const createAccountsOrder = async (orderSchedulingNr, filteredData) => {
    try {
      const selectedCustomer = accountsCustomers.find(
        (customer) => String(customer.id) === String(selectedCustomerId),
      );

      const items = filteredData.map((item) => ({
        description:
          item.materialDescription ||
          item.materialLongText ||
          item.material ||
          "",

        quantity: Number(item.orderQuantityLoad) || 0,

        unit: item.uOM || item.unitIn || "",

        rate: Number(item.unitPrice) || 0,

        amount:
          (Number(item.orderQuantityLoad) || 0) * (Number(item.unitPrice) || 0),
      }));

      const payload = {
        orderNo: orderSchedulingNr || "",

        customerId: String(selectedCustomerId),

        customerName: selectedCustomer?.name || formInputs?.customerName || "",

        orderDate: getTodayDate(""),

        items,

        totalAmount: Number(orderTotalValue) || 0,

        remarks: formInputs?.remarks?.trim() || "",

        status: "APPROVED",

        creditCheck: {
          creditLimit: Number(customerCredit?.creditLimit) || 0,

          outstanding: Number(customerCredit?.outstanding) || 0,

          openOrders: Number(customerCredit?.openOrders) || 0,

          orderAmount: Number(orderTotalValue) || 0,

          exceededBy: 0,

          passed: true,
        },

        approvedAt: null,

        approvalNote: "",

        cancelledAt: null,

        cancelReason: "",
      };

      console.log(
        "Accounts saveOrder Payload:",
        JSON.stringify(payload, null, 2),
      );

      return await accountsApi.saveOrder(payload);
    } catch (error) {
      console.error("createAccountsOrder error:", error);

      throw error;
    }
  };

  //old code
  // const handleSave = async () => {
  //   if (getProductDetailsData.length === 0) {
  //     toast.error("Please add atleast one record!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });

  //     return;
  //   }

  //   const finalobj = getProductDetailsData.map((item) => ({
  //     ...item,
  //     ...formInputs,
  //   }));

  //   const filteredData = finalobj.map(({ _id, ...rest }) => rest);

  //   const hasEmptyOrderQuantityLoad = filteredData.some(
  //     (item) =>
  //       !item.orderQuantityLoad ||
  //       item.orderQuantityLoad.toString().trim() === "",
  //   );

  //   const hasEmptyUnitPrice = filteredData.some(
  //     (item) =>
  //       item.unitPrice === undefined ||
  //       item.unitPrice === null ||
  //       item.unitPrice.toString().trim() === "" ||
  //       Number(item.unitPrice) === 0,
  //   );

  //   const hasMissingTruckNo = filteredData.some(
  //     (item) =>
  //       item.exWork === "Ex-Work" &&
  //       (!item.loadingTruckNo || item.loadingTruckNo.toString().trim() === ""),
  //   );

  //   if (hasMissingTruckNo) {
  //     toast.error("Truck No is required for Ex-Work orders!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });

  //     return;
  //   }

  //   if (hasEmptyOrderQuantityLoad) {
  //     toast.error("Bag value should not be empty !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });

  //     return;
  //   }

  //   if (hasEmptyUnitPrice) {
  //     toast.error("Unit price should not be empty or zero !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });

  //     return;
  //   }

  //   const invalidShippingRow = finalobj.find(
  //     (row) =>
  //       row.shippingAddress?.trim() &&
  //       !row.shippingPostalCode?.toString().trim(),
  //   );

  //   if (invalidShippingRow) {
  //     toast.error("Please fill the Shipping Postal Code", {
  //       duration: 4000,
  //       position: "top-right",
  //     });

  //     return;
  //   }

  //   // ---- creditCheck values ----
  //   const orderAmount = Number(orderTotalValue) || 0;
  //   const creditLimitVal = Number(customerCredit?.creditLimit) || 0;
  //   const outstandingVal = Number(customerCredit?.outstanding) || 0;
  //   const openOrdersVal = Number(customerCredit?.openOrders) || 0;

  //   const exceededBy = Math.max(
  //     0,
  //     outstandingVal + openOrdersVal + orderAmount - creditLimitVal,
  //   );

  //   const obj = {
  //     data: {
  //       salesOrderStatus: "Created",

  //       version: "V0",

  //       customerId: String(selectedCustomerId),

  //       companyCode: filteredData[0].companyCode,

  //       companyCodeDesc: filteredData[0].companyCodeDesc,

  //       customerCode: filteredData[0].customerCode || "",

  //       customerName:
  //         filteredData[0].customerName || getCustomerDetails?.customerName,

  //       deliveryName: filteredData[0].projectName,

  //       address: getCustomerDetails?.address,

  //       address2: getCustomerDetails?.address2,

  //       address3: getCustomerDetails?.address3,

  //       state: getCustomerDetails?.state,

  //       cityPostalCode: getCustomerDetails?.cityPostalCode,

  //       certifications: getCustomerDetails?.certifications,

  //       creditLimitAmt: parseFloat(getCustomerDetails?.creditLimitAmt) || "",

  //       creditOutStandingAmt:
  //         parseFloat(getCustomerDetails?.creditOutStandingAmt) || "",

  //       creditAvailableAmt:
  //         parseFloat(getCustomerDetails?.creditAvailableAmt) || "",

  //       creditLimitExpiryDate: getCustomerDetails?.creditLimitExpiryDate || "",

  //       creditPeriod: getCustomerDetails?.creditPeriod || "",

  //       orderTotalValue: parseFloat(orderTotalValue) || "",

  //       othersCustomerStatus: othersCustomer,

  //       addOnInvoiceStatus: addOnInv,

  //       invcustomerName: addOnInv
  //         ? getCustomerDetails?.invcustomerName || ""
  //         : "",

  //       invAddress: addOnInv ? getCustomerDetails?.invAddress || "" : "",

  //       invCityPostalCode: addOnInv
  //         ? getCustomerDetails?.invCityPostalCode || ""
  //         : "",

  //       invCustomerContactName: addOnInv
  //         ? getCustomerDetails?.invCustomerContactName || ""
  //         : "",

  //       invCustomerContactNumber: addOnInv
  //         ? getCustomerDetails?.invCustomerContactNumber || ""
  //         : "",

  //       otherCustomerContactName:
  //         getCustomerDetails?.otherCustomerContactName || "",

  //       otherCustomerContactNumber:
  //         getCustomerDetails?.otherCustomerContactNumber || "",

  //       companyAddress: [
  //         getCompanyDetails?.address,
  //         getCompanyDetails?.address2,
  //         getCompanyDetails?.address3,
  //         getCompanyDetails?.city,
  //         getCompanyDetails?.state,
  //       ]
  //         .filter(Boolean)
  //         .join(" "),

  //       companyPostalCode: getCompanyDetails?.cityPostalCode,

  //       companyCertifications: getCompanyDetails?.certifications,

  //       companyBankDetails: getCompanyDetails?.bandkDetails,

  //       companyContact: [
  //         {
  //           contant1: "9448380669",
  //         },
  //         {
  //           contant2: "7411677666",
  //         },
  //       ],

  //       companyMail: "svah2003@gmail.com",

  //       projectAddress: getProjectDetailsSave?.projectAddress,

  //       projectAddress2: getProjectDetailsSave?.projectAddress2,

  //       projectCity: getProjectDetailsSave?.projectCity,

  //       projectCityPostalCode: getProjectDetailsSave?.projectCityPostalCode,

  //       projectCode: getProjectDetailsSave?.projectCode,

  //       projectCodeDesc: getProjectDetailsSave?.projectCodeDesc,

  //       projectCountry: getProjectDetailsSave?.projectCountry,

  //       projectName: getProjectDetailsSave?.projectName,

  //       projectState: getProjectDetailsSave?.projectState,

  //       salesOfficerCode: userData?.userId,

  //       salesOfficerName: userData?.firstName,

  //       salesOfficerEmail: userData?.email,

  //       salesOfficerContactNr: userData?.contactNumber,

  //       items: filteredData,

  //       additionalCreditAmt: formInputs?.additionalCreditAmt || "",

  //       // ---- keys added for Accounts ----
  //       orderDate: getTodayDate(""),
  //       totalAmount: orderAmount,
  //       remarks: formInputs?.remarks?.trim() || "",
  //       status: "APPROVED",

  //       creditCheck: {
  //         creditLimit: creditLimitVal,
  //         outstanding: outstandingVal,
  //         openOrders: openOrdersVal,
  //         orderAmount: orderAmount,
  //         exceededBy: Number(exceededBy.toFixed(2)),
  //         passed: exceededBy === 0,
  //       },

  //       approvedAt: null,
  //       approvalNote: "",
  //       cancelledAt: null,
  //       cancelReason: "",
  //     },
  //   };

  //   console.log("API 1 customerId:", obj.data.customerId);

  //   console.log("API 1 Payload:", JSON.stringify(obj, null, 2));

  //   setDisabled(true);

  //   try {
  //     const item = await ItemServiceV2.addOrderScheduleBookingV2(obj);

  //     console.log("API 1 Response:", JSON.stringify(item, null, 2));

  //     if (item?.status === 200) {
  //       toast.success(item?.message || "added successfully", {
  //         duration: 2000,
  //         position: "top-right",
  //       });

  //       if (typeof props.onHide === "function") {
  //         props.onHide();
  //       }

  //       navigate(-1);
  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);

  //     toast.error("Something went wrong. Please try again !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //   } finally {
  //     setDisabled(false);
  //   }
  // };

  // const toNum = (v, d = 0) => {
  //   if (v === null || v === undefined || v === "") return d;
  //   const n =
  //     typeof v === "number" ? v : Number(String(v).replace(/[^0-9.-]/g, ""));
  //   return Number.isFinite(n) ? n : d;
  // };
  // const handleSave = async () => {
  //   if (getProductDetailsData.length === 0) {
  //     toast.error("Please add atleast one record!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //     return;
  //   }

  //   const finalobj = getProductDetailsData.map((item) => ({
  //     ...item,
  //     ...formInputs,
  //   }));
  //   const filteredData = finalobj.map(({ id, ...rest }) => rest);

  //   const hasEmptyOrderQuantityLoad = filteredData.some(
  //     (item) =>
  //       !item.orderQuantityLoad ||
  //       item.orderQuantityLoad.toString().trim() === "",
  //   );
  //   const hasEmptyUnitPrice = filteredData.some(
  //     (item) =>
  //       item.unitPrice === undefined ||
  //       item.unitPrice === null ||
  //       item.unitPrice.toString().trim() === "" ||
  //       Number(item.unitPrice) === 0,
  //   );
  //   const hasMissingTruckNo = filteredData.some(
  //     (item) =>
  //       item.exWork === "Ex-Work" &&
  //       (!item.loadingTruckNo || item.loadingTruckNo.toString().trim() === ""),
  //   );

  //   if (hasMissingTruckNo) {
  //     toast.error("Truck No is required for Ex-Work orders!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //     return;
  //   }
  //   if (hasEmptyOrderQuantityLoad) {
  //     toast.error("Bag value should not be empty !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //     return;
  //   }
  //   if (hasEmptyUnitPrice) {
  //     toast.error("Unit price should not be empty or zero !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //     return;
  //   }

  //   const invalidShippingRow = finalobj.find(
  //     (row) =>
  //       row.shippingAddress?.trim() &&
  //       !row.shippingPostalCode?.toString().trim(),
  //   );
  //   if (invalidShippingRow) {
  //     toast.error("Please fill the Shipping Postal Code", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //     return;
  //   }

  //   // ---- creditCheck values (all numbers) ----
  //   const orderAmount = toNum(orderTotalValue);
  //   const creditLimitVal = toNum(customerCredit?.creditLimit);
  //   const outstandingVal = toNum(customerCredit?.outstanding);
  //   const openOrdersVal = toNum(customerCredit?.openOrders);
  //   const exceededBy = Math.max(
  //     0,
  //     +(outstandingVal + openOrdersVal + orderAmount - creditLimitVal).toFixed(
  //       2,
  //     ),
  //   );

  //   const obj = {
  //     data: {
  //       salesOrderStatus: "Created",
  //       version: "V0",
  //       // customerId: String(selectedCustomerId),
  //       customerId: new ObjectId(selectedCustomerId),
  //       companyCode: filteredData[0].companyCode,
  //       companyCodeDesc: filteredData[0].companyCodeDesc,
  //       customerCode: filteredData[0].customerCode || "",
  //       customerName:
  //         filteredData[0].customerName || getCustomerDetails?.customerName,
  //       deliveryName: filteredData[0].projectName,
  //       address: getCustomerDetails?.address,
  //       address2: getCustomerDetails?.address2,
  //       address3: getCustomerDetails?.address3,
  //       state: getCustomerDetails?.state,
  //       cityPostalCode: getCustomerDetails?.cityPostalCode,
  //       certifications: getCustomerDetails?.certifications,
  //       creditLimitAmt: toNum(
  //         getCustomerDetails?.creditLimitAmt ??
  //           getCustomerDetails?.companyProfile?.creditMaxLimit,
  //       ),
  //       creditOutStandingAmt: toNum(getCustomerDetails?.creditOutStandingAmt),
  //       creditAvailableAmt: toNum(getCustomerDetails?.creditAvailableAmt),
  //       creditLimitExpiryDate: getCustomerDetails?.creditLimitExpiryDate,
  //       creditPeriod: getCustomerDetails?.creditPeriod,
  //       orderTotalValue: orderAmount,
  //       othersCustomerStatus: othersCustomer,
  //       addOnInvoiceStatus: addOnInv,
  //       invcustomerName: addOnInv ? getCustomerDetails?.invcustomerName : "",
  //       invAddress: addOnInv ? getCustomerDetails?.invAddress : "",
  //       invCityPostalCode: addOnInv
  //         ? getCustomerDetails?.invCityPostalCode
  //         : "",
  //       invCustomerContactName: addOnInv
  //         ? getCustomerDetails?.invCustomerContactName
  //         : "",
  //       invCustomerContactNumber: addOnInv
  //         ? getCustomerDetails?.invCustomerContactNumber
  //         : "",
  //       otherCustomerContactName: getCustomerDetails?.otherCustomerContactName,
  //       otherCustomerContactNumber:
  //         getCustomerDetails?.otherCustomerContactNumber,
  //       companyAddress: [
  //         getCompanyDetails?.address,
  //         getCompanyDetails?.address2,
  //         getCompanyDetails?.address3,
  //         getCompanyDetails?.city,
  //         getCompanyDetails?.state,
  //       ]
  //         .filter(Boolean)
  //         .join(", "),
  //       companyPostalCode: getCompanyDetails?.cityPostalCode,
  //       companyCertifications: getCompanyDetails?.certifications,
  //       companyBankDetails: getCompanyDetails?.bandkDetails,
  //       companyContact: { contant1: "9448380669", contant2: "7411677666" },
  //       companyMail: "svah2003@gmail.com",
  //       projectAddress: getProjectDetailsSave?.projectAddress,
  //       projectAddress2: getProjectDetailsSave?.projectAddress2,
  //       projectCity: getProjectDetailsSave?.projectCity,
  //       projectCityPostalCode: getProjectDetailsSave?.projectCityPostalCode,
  //       projectCode: getProjectDetailsSave?.projectCode,
  //       projectCodeDesc: getProjectDetailsSave?.projectCodeDesc,
  //       projectCountry: getProjectDetailsSave?.projectCountry,
  //       projectName: getProjectDetailsSave?.projectName,
  //       projectState: getProjectDetailsSave?.projectState,
  //       salesOfficerCode: userData?.userId,
  //       salesOfficerName: userData?.firstName,
  //       salesOfficerEmail: userData?.email,
  //       salesOfficerContactNr: userData?.contactNumber,
  //       items: filteredData,
  //       additionalCreditAmt: toNum(formInputs?.additionalCreditAmt),

  //       // ---- keys added for Accounts ----
  //       orderDate: getTodayDate(),
  //       totalAmount: orderAmount,
  //       remarks: formInputs?.remarks?.trim() || "",
  //       status: "APPROVED",
  //       creditCheck: {
  //         creditLimit: creditLimitVal,
  //         outstanding: outstandingVal,
  //         openOrders: openOrdersVal,
  //         orderAmount,
  //         exceededBy,
  //         passed: exceededBy === 0,
  //       },
  //       approvedAt: null,
  //       approvalNote: "",
  //       cancelledAt: null,
  //       cancelReason: "",
  //     },
  //   };

  //   console.log("API 1 customerId", obj.data.customerId);
  //   console.log("API 1 Payload", JSON.stringify(obj, null, 2));

  //   setDisabled(true);
  //   try {
  //     const item = await ItemServiceV2.addOrderScheduleBookingV2(obj);
  //     console.log("API 1 Response", JSON.stringify(item, null, 2));
  //     if (item?.status === 200) {
  //       toast.success(`${item?.message} added successfully`, {
  //         duration: 2000,
  //         position: "top-right",
  //       });
  //       if (typeof props.onHide === "function") props.onHide();
  //       navigate(-1);
  //     } else {
  //       toast.error(`${item?.message} Please try again !!`, {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Something went wrong. Please try again !!", {
  //       duration: 4000,
  //       position: "top-right",
  //     });
  //   } finally {
  //     setDisabled(false);
  //   }
  // };
 // eslint-disable-next-line 
  const toNum = (v, d = 0) => {
    if (v === null || v === undefined || v === "") return d;
    const n =
      typeof v === "number" ? v : Number(String(v).replace(/[^0-9.-]/g, ""));
    return Number.isFinite(n) ? n : d;
  };

  //dont remove ledger code
  const handleSave = async () => {
    if (getProductDetailsData.length === 0) {
      toast.error("Please add atleast one record!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const finalobj = getProductDetailsData.map((item) => ({
      ...item,
      ...formInputs,
    }));

    const filteredData = finalobj.map(({ id, ...rest }) => rest);

    const hasEmptyOrderQuantityLoad = filteredData.some(
      (item) =>
        item.orderQuantityLoad === undefined ||
        item.orderQuantityLoad === null ||
        item.orderQuantityLoad.toString().trim() === "" ||
        Number(item.orderQuantityLoad) <= 0,
    );

    const hasEmptyUnitPrice = filteredData.some(
      (item) =>
        item.unitPrice === undefined ||
        item.unitPrice === null ||
        item.unitPrice.toString().trim() === "" ||
        Number(item.unitPrice) <= 0,
    );

    const hasMissingTruckNo = filteredData.some(
      (item) =>
        item.exWork === "Ex-Work" &&
        (!item.loadingTruckNo || item.loadingTruckNo.toString().trim() === ""),
    );

    if (hasMissingTruckNo) {
      toast.error("Truck No is required for Ex-Work orders!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    if (hasEmptyOrderQuantityLoad) {
      toast.error("Bag value should not be empty or zero !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    if (hasEmptyUnitPrice) {
      toast.error("Unit price should not be empty or zero !!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const invalidShippingRow = filteredData.find(
      (row) =>
        row.shippingAddress?.trim() &&
        !row.shippingPostalCode?.toString().trim(),
    );

    if (invalidShippingRow) {
      toast.error("Please fill the Shipping Postal Code", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    const orderAmount = toNum(orderTotalValue);
    const creditLimitVal = toNum(customerCredit?.creditLimit);
    const outstandingVal = toNum(customerCredit?.outstanding);
    const openOrdersVal = toNum(customerCredit?.openOrders);

    const exceededBy = Math.max(
      0,
      Number(
        (outstandingVal + openOrdersVal + orderAmount - creditLimitVal).toFixed(
          2,
        ),
      ),
    );

    const items = filteredData.map((item) => ({
      ...item,
      quantity: Number(item.orderQuantityLoad) || 0,
      amount: Number(
        (
          (Number(item.orderQuantityLoad) || 0) * (Number(item.unitPrice) || 0)
        ).toFixed(2),
      ),
    }));
    const obj = {
      data: {
        salesOrderStatus: "Created",
        version: "V0",
        customerId: new ObjectId(selectedCustomerId),
        companyCode: filteredData[0].companyCode,
        companyCodeDesc: filteredData[0].companyCodeDesc,
        customerCode: filteredData[0].customerCode || "",
        customerName:
          filteredData[0].customerName || getCustomerDetails?.customerName,
        deliveryName: filteredData[0].projectName,
        address: getCustomerDetails?.address,
        address2: getCustomerDetails?.address2,
        address3: getCustomerDetails?.address3,
        state: getCustomerDetails?.state,
        cityPostalCode: getCustomerDetails?.cityPostalCode,
        certifications: getCustomerDetails?.certifications,
        creditLimitAmt: toNum(
          getCustomerDetails?.creditLimitAmt ??
            getCustomerDetails?.companyProfile?.creditMaxLimit,
        ),
        creditOutStandingAmt: toNum(getCustomerDetails?.creditOutStandingAmt),
        creditAvailableAmt: toNum(getCustomerDetails?.creditAvailableAmt),
        creditLimitExpiryDate: getCustomerDetails?.creditLimitExpiryDate,
        creditPeriod: getCustomerDetails?.creditPeriod,
        orderTotalValue: orderAmount,
        othersCustomerStatus: othersCustomer,
        addOnInvoiceStatus: addOnInv,
        invcustomerName: addOnInv
          ? getCustomerDetails?.invcustomerName || ""
          : "",
        invAddress: addOnInv ? getCustomerDetails?.invAddress || "" : "",
        invCityPostalCode: addOnInv
          ? getCustomerDetails?.invCityPostalCode || ""
          : "",
        invCustomerContactName: addOnInv
          ? getCustomerDetails?.invCustomerContactName || ""
          : "",
        invCustomerContactNumber: addOnInv
          ? getCustomerDetails?.invCustomerContactNumber || ""
          : "",
        otherCustomerContactName:
          getCustomerDetails?.otherCustomerContactName || "",
        otherCustomerContactNumber:
          getCustomerDetails?.otherCustomerContactNumber || "",
        companyAddress: [
          getCompanyDetails?.address,
          getCompanyDetails?.address2,
          getCompanyDetails?.address3,
          getCompanyDetails?.city,
          getCompanyDetails?.state,
        ]
          .filter(Boolean)
          .join(", "),
        companyPostalCode: getCompanyDetails?.cityPostalCode,
        companyCertifications: getCompanyDetails?.certifications,
        companyBankDetails: getCompanyDetails?.bandkDetails,
        companyContact: {
          contant1: "9448380669",
          contant2: "7411677666",
        },
        companyMail: "svah2003@gmail.com",
        projectAddress: getProjectDetailsSave?.projectAddress,
        projectAddress2: getProjectDetailsSave?.projectAddress2,
        projectCity: getProjectDetailsSave?.projectCity,
        projectCityPostalCode: getProjectDetailsSave?.projectCityPostalCode,
        projectCode: getProjectDetailsSave?.projectCode,
        projectCodeDesc: getProjectDetailsSave?.projectCodeDesc,
        projectCountry: getProjectDetailsSave?.projectCountry,
        projectName: getProjectDetailsSave?.projectName,
        projectState: getProjectDetailsSave?.projectState,
        salesOfficerCode: userData?.userId,
        salesOfficerName: userData?.firstName,
        salesOfficerEmail: userData?.email,
        salesOfficerContactNr: userData?.contactNumber,
        items,
        additionalCreditAmt: toNum(formInputs?.additionalCreditAmt),
        orderDate: getTodayDate(""),
        totalAmount: orderAmount,
        remarks: formInputs?.remarks?.trim() || "",
        status: "APPROVED",
        creditCheck: {
          creditLimit: creditLimitVal,
          outstanding: outstandingVal,
          openOrders: openOrdersVal,
          orderAmount,
          exceededBy,
          passed: exceededBy === 0,
        },
        approvedAt: null,
        approvalNote: "",
        cancelledAt: null,
        cancelReason: "",
      },
    };

    console.log("API 1 customerId", obj.data.customerId);
    console.log("API 1 Payload", JSON.stringify(obj, null, 2));

    setDisabled(true);

    try {
      const item = await ItemServiceV2.addOrderScheduleBookingV2(obj);

      console.log("API 1 Response", JSON.stringify(item, null, 2));

      if (item?.status === 200) {
        toast.success(`${item?.message || "Order"} added successfully`, {
          duration: 2000,
          position: "top-right",
        });

        if (typeof props.onHide === "function") {
          props.onHide();
        }

        navigate(-1);
      } else {
        toast.error(`${item?.message || "Please try again"} !!`, {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (error) {
      console.error(error);

      toast.error("Something went wrong. Please try again !!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setDisabled(false);
    }
  };

  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  const customerDataDropdown = async (code) => {
    let obj = {
      companyCode: code,
    };

    await ItemService.getCustomersByCompany(obj).then((item) => {
      if (item?.status === 200) {
        setCustomer(item?.data);
      } else {
        setCustomer([]);
        console.log(">> Error: Loading getCustomers");
      }
    });
  };

  const getCustomerDetail = async (userId) => {
    let obj1 = {
      documentNumber: userId,
    };
    await ItemService.getCustomerDetail(obj1).then((item) => {
      if (item?.status === 200) {
        setCustomerDetails(item?.data[0] || null);
        laodCutomerExtendedPeriod(item?.data[0]?.customerCode || "");
      } else {
        setCustomerDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const getCompanyMaster = async (code) => {
    let obj1 = {
      code: code,
    };
    await ItemServiceV2.getCompanyMaster(obj1).then((item) => {
      if (item?.status === 200) {
        setCompanyDetails(item?.data[0] || null);
      } else {
        setCompanyDetails([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };

  const getProjectNameData = async (userId) => {
    let obj1 = {
      userId: userId,
    };
    await ItemService.getProjectName(obj1).then((item) => {
      if (item?.status === 200) {
        const updatedData = item?.data?.map((item) => ({
          ...item,
          name: `${item.id} - ${item.projectAddress}`,
        }));

        setProjects(updatedData || []);
      } else {
        setProjects([]);
        console.log(">> Error: Loading getProjectName");
      }
    });
  };
  //eslint-disable-next-line
  const getProjectDetailsByCode = async (code) => {
    let obj = {
      userId: customerID,
      projectCode: code,
    };
    await ItemService.getProjectDetail(obj).then((item) => {
      if (item?.status === 200) {
        if (item?.data.length > 0) {
          setProjectDetails(
            item?.data[0]?.getLocations ? item?.data[0]?.getLocations[0] : [],
          );
          setProjectDetailsSave(item?.data[0]);
        } else {
          setProjectDetails([]);
        }
      } else {
        setProjectDetails([]);
        console.log(">> Error: Loading getProjectDetail");
      }
    });
  };

  const handleGetSelectedMaterial = (selectedData) => {
    setProductDetailsData((prevData) => {
      const customerAddress = [
        getCustomerDetails?.address,
        getCustomerDetails?.address2,
        getCustomerDetails?.address3,
        getCustomerDetails?.state,
      ]
        .filter(Boolean)
        .join(" ");

      const postalCode = getCustomerDetails?.cityPostalCode;

      const defaultPriority = priority.find((item) => item.name === "Medium");

      const existingIds = new Set(prevData.map((i) => i._id));
      const newItems = selectedData
        .filter((item) => !existingIds.has(item._id))
        .map((item) => ({
          ...item,
          dispatchDate: getTodayDate(""),
          orderStatus: "Pending",
          orderQuantityLoad: "",
          quantity: item?.orderQuantityLoad || "",
          priority: defaultPriority?.name || "",
          priorityCode: defaultPriority?.code || "",
          priorityDescription: defaultPriority?.name || "",

          shippingAddress: customerAddress,
          shippingPostalCode: postalCode ? Number(postalCode) : "",

          originalShippingAddress: customerAddress,
          originalShippingPostalCode: postalCode,

          isShippingEdited: false,
          isPostalEdited: false,

          customerAddress,
          customerPostalCode: postalCode,
          certifications: getCustomerDetails?.certifications,

          companyAddress: [
            getCompanyDetails?.address,
            getCompanyDetails?.address2,
            getCompanyDetails?.address3,
            getCompanyDetails?.city,
            getCompanyDetails?.state,
          ]
            .filter(Boolean)
            .join(" "),
          companyPostalCode: getCompanyDetails?.cityPostalCode,
          companyCertifications: getCompanyDetails?.certifications,
        }));

      return [...prevData, ...newItems].map((item, index) => ({
        ...item,
        local_id: index + 1,
      }));
    });
  };

  const handleCheckboxChange = (local_id, event) => {
    const checkedValue = event.target.checked ? true : false;

    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, accOnOff: checkedValue } : row,
      ),
    );
  };
  const handleDropdownChange = (data) => {
    setProductDetailsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === data.index
          ? {
              ...row,
              [data.name]: data.value,
              [data.code]: data.codeValue,
              [data.desc]: data.descValue,
            }
          : row,
      ),
    );
  };

  const addProductDetails = () => {
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.companyCode)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setValidation((prev) => ({
        ...prev,
        companyCode: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!othersCustomer) {
      if (!validateRequired(formInputs.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
    } else {
      if (!validateRequired(getCustomerDetails?.customerName)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          customerName: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.address)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          address: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (!validPostalCode(getCustomerDetails?.cityPostalCode)) {
        requiredFields.push(`${message.VALID_POSTAL_CODE}`);
        setValidation((prev) => ({
          ...prev,
          cityPostalCode: message.VALID_POSTAL_CODE,
        }));
        return;
      }
      if (!validateRequired(getCustomerDetails?.otherCustomerContactNumber)) {
        requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.FILL_REQUIRED_FIELD,
        }));
        return;
      }
      if (
        !validateContactNumber(getCustomerDetails?.otherCustomerContactNumber)
      ) {
        requiredFields.push(`${message.VALID_CONTACT_NUMBER}`);
        setValidation((prev) => ({
          ...prev,
          otherCustomerContactNumber: message.VALID_CONTACT_NUMBER,
        }));
        return;
      }
    }
    setModalShow(true);
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const currentAvailableAmt =
    getCustomerDetails?.companyProfile?.creditMaxLimit -
    (getCustomerDetails?.creditOutStandingAmt ?? 0) -
    (getCustomerDetails?.pendingOrderValue ?? 0) +
    Number(getCustomerDetails?.companyProfile?.limitToExtendedAmt ?? 0);

  // eslint-disable-next-line 
  const showCreditPolicyRequestForm = () => {
    setCreditPolicyFormModal(true);
  };

  const hideCreditPolicyRequestForm = () => {
    setCreditPolicyFormModal(false);
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  useEffect(() => {
    setOrderTotalValue("");
  }, [getCustomerDetails]);

  useEffect(() => {
    if (
      orderTotalValue === "" ||
      orderTotalValue === null ||
      orderTotalValue === undefined ||
      Number(orderTotalValue) === 0
    ) {
      setErrorFields([]);
      setShowFailureModal(false);
      setDisabled(false);
      setToggleCreditRequest(false);

      setValidation((prev) => {
        const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
        return rest;
      });

      return;
    }

    if (othersCustomer) {
      setErrorFields([]);
      setShowFailureModal(false);
      setDisabled(false);
      setToggleCreditRequest(false);

      setValidation((prev) => {
        const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
        return rest;
      });

      return;
    }

    // const availableAmt = Number(
    //   getCustomerDetails?.companyProfile?.creditAvailableAmt ??
    //     getCustomerDetails?.creditAvailableAmt ??
    //     0,
    // );

    // if (availableAmt === 0 || isNaN(availableAmt)) {
    //   setErrorFields([
    //     "No current available amount, Kindly create a credit limit extension request.",
    //   ]);
    //   setShowFailureModal(true);
    //   setDisabled(true);
    //   setToggleCreditRequest(true);

    //   setValidation((prev) => ({
    //     ...prev,
    //     currentAvailableAmt:
    //       "No current available amount. Kindly create a credit limit extension request.",
    //   }));
    //   return;
    // }

    setErrorFields([]);
    setShowFailureModal(false);
    setDisabled(false);
    setToggleCreditRequest(false);

    setValidation((prev) => {
      const { orderTotalValue, currentAvailableAmt, ...rest } = prev;
      return rest;
    });
    //eslint-disable-next-line
  }, [orderTotalValue, othersCustomer]);

  const [creditExtendedShow, setCreditExtendedShow] = useState(false);
  const [extendPeriodData, setExtendPeriodData] = useState([]);
  const extendPeriodColumn = [
    {
      name: "Sl.no",
      selector: (row, index) => index + 1,
      cell: (row, index) => <>{index + 1}</>,
      sortable: false,
      width: "100px",
    },
    {
      name: "Extended Amt",
      selector: (row) => row?.limitToExtendedAmt || "--",
      cell: (row) => <>{row?.limitToExtendedAmt}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Extended Days",
      selector: (row) => row?.periodToExtendedDays || "--",
      cell: (row) => <>{row?.periodToExtendedDays}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Status",
      selector: (row) => row?.cpHeaderStatus || "--",
      cell: (row) => (
        <>
          <TableStatusField status={row?.cpHeaderStatus} />
        </>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Credit Limit",
      selector: (row) => row?.companyProfile?.creditMaxLimit || "--",
      cell: (row) => (
        <div>
          <span>{row?.companyProfile?.creditMaxLimit}</span>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Update At",
      selector: (row) => row?.updatedAt || "--",
      cell: (row) => (
        <div>
          <span>{formatDateWithAMPM(row?.updatedAt)}</span>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Remark",
      selector: (row) => row?.remark || "--",
      cell: (row) => (
        <div>
          <span>{row?.remark}</span>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];
     // eslint-disable-next-line 
  const toggleCreditExtended = () => {
    setCreditExtendedShow(!creditExtendedShow);
  };

  const laodCutomerExtendedPeriod = async (customerId) => {
    const obj = {
      queryName: "getCreditPolicyListbyCustomer",
      rowFilter: {
        $and: [
          {
            customerId: customerId,
          },
        ],
      },
      page: 1,
      per_page: 99999,
    };
    await ItemServiceV2.generateCustomerQuery(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "Customer Extend Period Load ", {
          duration: 2000,
          position: "top-right",
        });
        setExtendPeriodData(item?.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  const creditLimit = Number(customerCredit?.creditLimit) || 0;

  const outstanding = Number(customerCredit?.outstanding) || 0;
   // eslint-disable-next-line 
  const amountDue = Number(customerCredit?.amountDue) || 0;

  const openOrders = Number(customerCredit?.openOrders) || 0;

  const currentOrderAmount = Number(orderTotalValue) || 0;

  const creditUsed = outstanding + openOrders + currentOrderAmount;

  const creditAvailable = creditLimit - creditUsed;

  const creditExceeded = creditAvailable < 0;

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Order Booking</h2>
            <p className="subText">Fill Create Order Booking Details</p>
            <hr />

            <div className="accordion mb-4" id="accordionCustomerDetails">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible1
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CD</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Customer Details</span>
                      <span className="subHeaderTitle">Customer Details</span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible1 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Name"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCode"
                          description="companyCodeDesc"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          required={true}
                          error={validation.companyCode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          className="inputBox"
                          label="Company Address"
                          name="companyAddress"
                          value={[
                            getCompanyDetails?.address,
                            getCompanyDetails?.address2,
                            getCompanyDetails?.address3,
                            getCompanyDetails?.city,
                            getCompanyDetails?.state,
                          ]
                            .filter(Boolean)
                            .join(" ")}
                          disabled={true}
                        />
                      </Col>

                      {!othersCustomer && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Customer Name"
                              placeholder=""
                              data={getCustomer}
                              id="customerName"
                              iconClassName="dropdownIcon"
                              name="customerName"
                              code="customerCode"
                              description="customerNameDesc"
                              setValue={formInputs?.customerName || ""}
                              getvalue={setDropdownData}
                              required={true}
                              error={validation.customerName}
                            />
                          </Col>
                            {userData?.category === "SALES" && (
                          <Col md={4}>
                            <label className="form-label">
                              Customer Name{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <select
                              className="form-select"
                              name="customerCode"
                              value={selectedCustomerId}
                              disabled={customerLoading}
                              // onChange={(e) => {
                              //   const id = e.target.value;

                              //   const selectedCustomer = accountsCustomers.find(
                              //     (customer) => String(customer.id) === id,
                              //   );

                              //   setSelectedCustomerId(id);

                              //   setFormInputs((prev) => ({
                              //     ...prev,
                              //     customerId: id,
                              //     customerCode:
                              //       selectedCustomer?.customerCode || "",
                              //     customerName: selectedCustomer?.name || "",
                              //     customerNameDesc:
                              //       selectedCustomer?.name || "",
                              //     projectName: "",
                              //   }));

                              //   setCustomerID(id);

                              //   setCustomerCredit(null);
                              //   setProjectDetails([]);
                              //   setProjectDetailsSave([]);

                              //   if (id) {
                              //     getCustomerCredit(id);
                              //   }
                              // }}
                              onChange={(e) => {
                                const id = e.target.value;

                                const selectedCustomer = accountsCustomers.find(
                                  (customer) =>
                                    String(customer.id) === String(id),
                                );

                                setSelectedCustomerId(id);

                                setFormInputs((prev) => ({
                                  ...prev,
                                  customerId: id,
                                  customerCode: selectedCustomer?.code || "",
                                  customerName: selectedCustomer?.name || "",
                                  customerNameDesc:
                                    selectedCustomer?.name || "",
                                  projectName: "",
                                }));

                                setCustomerID(id);
                                setCustomerCredit(null);
                                setCustomerDetails(selectedCustomer || null);
                                setProjectDetails([]);
                                setProjectDetailsSave([]);

                                if (id && selectedCustomer?.code) {
                                  getCustomerCredit(id);
                                  getCustomerDetail(selectedCustomer.code);
                                }
                              }}
                            >
                              <option value="">
                                {customerLoading
                                  ? "Loading customers..."
                                  : "Select Customer"}
                              </option>

                              {accountsCustomers
                                .filter(
                                  (customer) => customer.isActive !== false,
                                )
                                .map((customer) => (
                                  <option key={customer.id} value={customer.id}>
                                    {customer.name}
                                  </option>
                                ))}
                            </select>

                            {validation?.customerName && (
                              <small className="text-danger">
                                {validation.customerName}
                              </small>
                            )}
                          </Col>
                            )}

                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Customer Address"
                              name="projectAddress"
                              value={[
                                getCustomerDetails?.address,
                                getCustomerDetails?.address2,
                                getCustomerDetails?.address3,
                                getCustomerDetails?.state,
                                getCustomerDetails?.cityPostalCode,
                              ]
                                .filter(Boolean)
                                .join(" ")}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Code"
                              id="customerCode"
                              name="customerCode"
                              value={getCustomerDetails?.customerCode}
                              onChange={othersOnInputChange}
                              disabled={true}
                            />
                          </Col>
                        </>
                      )}

                      <Col
                        xs={12}
                        md={12}
                        lg={12}
                        className="commLeftRightPadding d-flex align-items-center"
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="othersCustomer"
                          checked={othersCustomer}
                          onChange={onCheckBoxChange}
                        />
                        <p className="m-0 ps-1 fw-medium text-dark ">Others </p>
                      </Col>

                      {othersCustomer && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              id="customerName"
                              name="customerName"
                              value={getCustomerDetails?.customerName}
                              onChange={othersOnInputChange}
                              required={true}
                              error={validation.customerName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Address"
                              id="address"
                              name="address"
                              value={getCustomerDetails?.address}
                              onChange={othersOnInputChange}
                              error={validation.address}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pin Code"
                              id="cityPostalCode"
                              name="cityPostalCode"
                              value={getCustomerDetails?.cityPostalCode}
                              onChange={othersOnInputChange}
                              error={validation.cityPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="otherCustomerContactName"
                              name="otherCustomerContactName"
                              value={
                                getCustomerDetails?.otherCustomerContactName
                              }
                              onChange={othersOnInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="otherCustomerContactNumber"
                              name="otherCustomerContactNumber"
                              value={
                                getCustomerDetails?.otherCustomerContactNumber
                              }
                              onChange={othersOnInputChange}
                              error={validation.otherCustomerContactNumber}
                            />
                          </Col>
                        </>
                      )}

                      <Col
                        xs={12}
                        md={12}
                        lg={12}
                        className="commLeftRightPadding d-flex align-items-center"
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="addOnInv"
                          checked={addOnInv}
                          onChange={addOnInvoiceChange}
                        />
                        <p className="m-0 ps-1 fw-medium text-dark ">
                          Add-on Invoice{" "}
                        </p>
                      </Col>
                      {addOnInv && (
                        <>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Inv Customer Name"
                              id="invcustomerName"
                              name="invcustomerName"
                              value={getCustomerDetails?.invcustomerName}
                              onChange={othersOnInputChange}
                              required={true}
                              error={validation.invcustomerName}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Inv Address"
                              id="invAddress"
                              name="invAddress"
                              value={getCustomerDetails?.invAddress}
                              onChange={othersOnInputChange}
                              error={validation.invAddress}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Inv Pin Code"
                              id="invCityPostalCode"
                              name="invCityPostalCode"
                              value={getCustomerDetails?.invCityPostalCode}
                              onChange={othersOnInputChange}
                              error={validation.invCityPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="invCustomerContactName"
                              name="invCustomerContactName"
                              value={getCustomerDetails?.invCustomerContactName}
                              onChange={othersOnInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="invCustomerContactNumber"
                              name="invCustomerContactNumber"
                              value={
                                getCustomerDetails?.invCustomerContactNumber
                              }
                              onChange={othersOnInputChange}
                              error={validation.invCustomerContactNumber}
                            />
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionCreditLimit">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CL</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Customer Credit Limit</span>
                      <span className="subHeaderTitle">
                        Credit Limit Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {selectedCustomerId && (
  <div className="mt-3 mb-4">
    <div
      className="card border-0 shadow-sm"
      style={{
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        className="px-3 py-2 d-flex justify-content-between align-items-center"
        style={{
          background:
            creditExceeded
              ? "#fff1f2"
              : "#f8fafc",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <div
            style={{
              width: "34px",
              height: "34px",
              borderRadius: "8px",
              background: creditExceeded
                ? "#fee2e2"
                : "#e0f2fe",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i
              className={`bi ${
                creditExceeded
                  ? "bi-exclamation-triangle"
                  : "bi-credit-card"
              }`}
              style={{
                fontSize: "17px",
                color: creditExceeded
                  ? "#dc2626"
                  : "#0369a1",
              }}
            />
          </div>

          <div>
            {/* <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#1f2937",
              }}
            >
              Customer Credit
            </div> */}

            <div
              style={{
                fontSize: "16px",
                color: "#6b7280",
              }}
            >
              Credit availability for this order
            </div>
          </div>
        </div>

        {creditLoading && (
          <div className="d-flex align-items-center gap-2">
            <div
              className="spinner-border spinner-border-sm"
              role="status"
            />
            <span
              style={{
                fontSize: "12px",
                color: "#6b7280",
              }}
            >
              Loading...
            </span>
          </div>
        )}
      </div>

      {/* Body */}
      <div className="p-3">
        {creditError ? (
          <div className="alert alert-danger mb-0 py-2">
            <i className="bi bi-exclamation-circle me-2" />
            {creditError}
          </div>
        ) : customerCredit ? (
          <>
            <div className="row g-3">

              {/* Credit Limit */}
              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    background: "#f8fafc",
                    borderRadius: "10px",
                    border: "1px solid #e5e7eb",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6b7280",
                    }}
                  >
                    Credit Limit
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#111827",
                    }}
                  >
                    ₹{creditLimit.toFixed(2)}
                  </div>
                </div>
              </div>

              {/* Outstanding */}
              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    background: "#fff7ed",
                    borderRadius: "10px",
                    border: "1px solid #fed7aa",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#9a3412",
                    }}
                  >
                    Outstanding
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#c2410c",
                    }}
                  >
                    ₹{outstanding.toFixed(2)}
                  </div>
                </div>
              </div>

              {/* Open Orders */}
              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    background: "#eff6ff",
                    borderRadius: "10px",
                    border: "1px solid #bfdbfe",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#1d4ed8",
                    }}
                  >
                    Open Orders
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#1d4ed8",
                    }}
                  >
                    ₹{openOrders.toFixed(2)}
                  </div>
                </div>
              </div>

              {/* This Order */}
              <div className="col-md-3">
                <div
                  className="p-3 h-100"
                  style={{
                    background: "#f5f3ff",
                    borderRadius: "10px",
                    border: "1px solid #ddd6fe",
                  }}
                >
                  <div
                    style={{
                      fontSize: "11px",
                      color: "#6d28d9",
                    }}
                  >
                    This Order
                  </div>

                  <div
                    className="mt-1"
                    style={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#6d28d9",
                    }}
                  >
                    ₹{currentOrderAmount.toFixed(2)}
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Credit Summary */}
            <div
              className="mt-3 p-3 d-flex justify-content-between align-items-center"
              style={{
                borderRadius: "10px",
                background: creditExceeded
                  ? "#fef2f2"
                  : "#f0fdf4",
                border: `1px solid ${
                  creditExceeded
                    ? "#fecaca"
                    : "#bbf7d0"
                }`,
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                  }}
                >
                  Credit Available After This Order
                </div>

                <div
                  style={{
                    fontSize: "22px",
                    fontWeight: 700,
                    color: creditExceeded
                      ? "#dc2626"
                      : "#15803d",
                  }}
                >
                  ₹{creditAvailable.toFixed(2)}
                </div>
              </div>

              <div className="text-end">
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                  }}
                >
                  Credit Days
                </div>

                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  {customerCredit?.creditDays ?? 0} Days
                </div>
              </div>

              <div>
                {creditExceeded ? (
                  <span className="badge bg-danger px-3 py-2">
                    <i className="bi bi-x-circle me-1" />
                    Credit Exceeded
                  </span>
                ) : (
                  <span className="badge bg-success px-3 py-2">
                    <i className="bi bi-check-circle me-1" />
                    Credit Available
                  </span>
                )}
              </div>
            </div>
          </>
        ) : (
          <div
            className="text-center py-3"
            style={{
              color: "#6b7280",
              fontSize: "13px",
            }}
          >
            Select a customer to view credit details
          </div>
        )}
      </div>
    </div>
  </div>
)}

                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* {!othersCustomer && getCustomerDetails && ( */}
            {/* <div className="accordion mb-4" id="accordionCreditLimit">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CL</span>
                    </Col>
                    <Col xs={12} md={9} lg={9}>
                      <span className="headerTitle">Customer Credit Limit</span>
                      <span className="subHeaderTitle">
                        Credit Limit Details
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Limit Amt"
                          id="creditLimit"
                          name="creditLimit"
                          // value={
                          //   getCustomerDetails?.companyProfile?.creditMaxLimit
                          // }
                          value={
                            customerCredit ? customerCredit.creditLimit : ""
                          }
                          disabled={true}
                          error={validation.creditLimit}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Current Outstanding Amt (Invoice)"
                          id="outstanding"
                          name="outstanding"
                          // value={
                          //   getCustomerDetails?.outstanding ?? 0
                          // }
                          value={
                            customerCredit ? customerCredit.outstanding : ""
                          }
                          disabled={true}
                          error={validation.creditOutStandingAmt}
                        />
                      </Col>
                        <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Due Amt"
                          id="amountDue"
                          name="amountDue"
                          // value={currentAvailableAmt}
                          value={customerCredit ? customerCredit.amountDue : ""}
                          disabled={true}
                          error={validation.amountDue}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Open Orders"
                          id="openOrders"
                          name="openOrders"
                          // value={
                          //   getCustomerDetails?.companyProfile?.openOrders
                          // }
                          value={
                            customerCredit ? customerCredit.openOrders : ""
                          }
                          disabled={true}
                          error={validation.openOrders}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Days"
                          id="creditDays"
                          name="creditDays"
                          // value={getCustomerDetails?.creditDays ?? 0}
                          value={
                            customerCredit ? customerCredit.creditDays : ""
                          }
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Credit Available Amt "
                          id="availableCredit"
                          name="availableCredit"
                          // value={currentAvailableAmt}
                          value={
                            customerCredit ? customerCredit.availableCredit : ""
                          }
                          disabled={true}
                          error={validation.currentAvailableAmt}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Not Yet Due Amt"
                          id="notYetDue"
                          name="notYetDue"
                          // value={currentAvailableAmt}
                          value={customerCredit ? customerCredit.notYetDue : ""}
                          disabled={true}
                          error={validation.currentAvailableAmt}
                        />
                      </Col>
                    
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <button
                          className="btn btn-table"
                          onClick={toggleCreditExtended}
                        >
                          Credit Extended
                        </button>
                      </Col>
                      {toggleCreditRequest && (
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <button
                            className="btn btnInfo mr-4"
                            onClick={() => showCreditPolicyRequestForm()}
                          >
                            Credit Request
                          </button>
                        </Col>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}
            {/* )} */}

            {creditExtendedShow && (
              <div className="accordion mb-4" id="accordionCreditExtended">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">CE</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          Credit Extended List
                        </span>
                        <span className="subHeaderTitle">
                          Credit Extended List Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={extendPeriodColumn}
                            data={extendPeriodData}
                            pagination
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div
              className="accordion sri-venkateshwara mb-4"
              id="accordionProducts"
            >
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PD</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Product Details</span>
                      <span className="subHeaderTitle">Product Details</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2}>
                        <button
                          className="btnTable"
                          onClick={addProductDetails}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={getProductDetailsCol}
                          data={getProductDetailsData}
                          pagination
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="rowDirection mb-4 pb-4">
        <Col xs={12} md={2} lg={2}>
          <button className="btnTable" onClick={handleSave} disabled={disable}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <MaterialSelectionModal
        show={modalShow}
        onHide={() => hideModal()}
        onselectedcatdata={handleGetSelectedMaterial}
      />
      <CreditPolicyRequestFormOrderBookingModal
        show={getCreditPolicyFormModal}
        onHide={() => hideCreditPolicyRequestForm()}
        getCustomerDetails={getCustomerDetails}
        getCompanyDetails={getCompanyDetails}
        currentAvailableAmt={currentAvailableAmt}
      />
      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
});

export default OrderBookingCreation;
